export const socketActionTypes = {
    SOCKET_CONNECT_REQUESTED:   'SK1',
    SOCKET_DISCONNECT_REQUESTED:'SK2',
    SOCKET_STATUS_CHANGED:      'SK3',
    SOCKET_CONNECT_FAILED:      'SK4',
};

export const SOCKET_STATUS = {
    IDLE:         'idle',
    CONNECTING:   'connecting',
    CONNECTED:    'connected',
    RECONNECTING: 'reconnecting',
    DISCONNECTED: 'disconnected',
};
